import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { getEntityUrl } from '@culture/utils/helpers/entities';
import _ from 'underscore';
import { getNumericDeclension } from '@culture/common-helpers/string';
import EntityPropTypes from 'propTypes/entities';
import {
	cardCropTextDefault,
	imageCardSizeDefault
} from 'utils/helpers/entities';

import BaseCard from './BaseCard';

const wordVariants = {
	institutes: {
		single: 'Место',
		some: 'Места',
		many: 'Мест'
	},
	objects: {
		single: 'Объект наследия',
		some: 'Объекта наследия',
		many: 'Объектов наследия'
	}
};

const TouristRouteCard = ({
	className,
	cropTextParams,
	entity,
	params,
	typeWidth
}) => {
	const { title, thumbnailFile, items, onFocus } = entity;
	const url = getEntityUrl('touristRoutes', entity);

	const description = useMemo(() => {
		const entitesCountDictionary = !_.isEmpty(items)
			? items.reduce((acc, item) => {
					const dict = { ...acc };
					const { entityType } = item;
					const countInDictionary = dict[entityType]?.count;
					const newCount = 1 + (countInDictionary ?? 0);
					dict[entityType] = {
						count: newCount,
						declension: getNumericDeclension(newCount, wordVariants[entityType])
					};
					return dict;
			  }, {})
			: null;

		return entitesCountDictionary
			? Object.values(entitesCountDictionary)
					.map((item) => `${item.count} ${item.declension.toLowerCase()}`)
					.join(', ')
			: null;
	}, [items?.length]);

	return (
		<BaseCard
			{...{
				className,
				cropTextParams,
				onFocus,
				params,
				thumbnailFile,
				title,
				typeWidth,
				url,
				description
			}}
		/>
	);
};

TouristRouteCard.propTypes = {
	className: PropTypes.string,
	cropTextParams: PropTypes.shape({
		title: PropTypes.string,
		description: PropTypes.string
	}),
	entity: EntityPropTypes.touristRoute.isRequired,
	onFocus: PropTypes.func,
	params: PropTypes.shape({
		width: PropTypes.number.isRequired,
		height: PropTypes.number.isRequired
	}),
	typeWidth: PropTypes.oneOf([
		'fixedLandscape',
		'fluidLandscapeSlide',
		'landingLandscape'
	])
};

TouristRouteCard.defaultProps = {
	cropTextParams: cardCropTextDefault,
	params: imageCardSizeDefault.landscape
};

export default TouristRouteCard;
